import React from 'react'
import styled from 'styled-components'
import { bool, func, string } from 'prop-types'

/* Eye icons from the Hey You design system (Figma node 623-0) */
const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5747 14.5913C18.4915 13.8799 19.2945 13.0521 20.0329 12.1585C20.0934 12.0846 20.0828 12.0441 20.0299 11.9798C19.4588 11.2912 18.8514 10.637 18.1775 10.0482C17.9547 9.85325 17.7294 9.66136 17.4749 9.47807C18.2345 11.2051 18.236 12.9154 17.4925 14.6283C17.5276 14.6331 17.5456 14.6169 17.5622 14.602C17.5664 14.5982 17.5705 14.5945 17.5747 14.5913ZM7.46769 12.0572C7.46165 14.685 9.63154 16.6606 11.993 16.614C14.3302 16.6677 16.5258 14.7376 16.5359 12.0724C16.5454 9.56415 14.5096 7.52068 12.0086 7.51814C9.47327 7.51561 7.47324 9.57377 7.46769 12.0572ZM5.65164 13.9407C5.9208 14.1837 6.19651 14.4202 6.49742 14.6288C5.76656 12.9098 5.77009 11.2005 6.52363 9.48212C6.51285 9.4894 6.5034 9.49559 6.49493 9.50114C6.47687 9.51298 6.46324 9.52191 6.45054 9.53225C5.51555 10.2548 4.6985 11.0967 3.94899 12.0086C3.89802 12.0702 3.92527 12.103 3.95792 12.1423C3.96013 12.1449 3.96237 12.1476 3.96462 12.1504C4.48731 12.7853 5.04175 13.3893 5.65164 13.9407ZM21.6677 11.612C21.7654 11.7386 21.8631 11.8651 21.9624 11.9904C22.0052 12.0446 22.0168 12.0815 21.9689 12.1448C21.1433 13.243 20.2567 14.285 19.2244 15.1953C17.8812 16.3801 16.3882 17.297 14.6528 17.7816C13.4869 18.1071 12.3019 18.2099 11.0968 18.1011C9.01106 17.9127 7.18341 17.0894 5.53672 15.8221C4.33408 14.8971 3.30836 13.7974 2.38344 12.598C2.3448 12.5478 2.3065 12.4974 2.26819 12.447C2.19158 12.3462 2.11496 12.2454 2.03566 12.1468C1.99382 12.0947 1.98525 12.0608 2.0291 12.0025C3.08456 10.5915 4.24789 9.28466 5.66323 8.22242C6.97777 7.23562 8.41882 6.52274 10.0358 6.19566C10.2525 6.15161 10.4713 6.11465 10.6905 6.08478C11.1265 6.02503 11.565 5.99719 11.8271 6.00022C14.122 5.99972 16.0344 6.65185 17.7824 7.82699C19.108 8.71861 20.2315 9.82844 21.2371 11.0643C21.3836 11.2443 21.5256 11.4281 21.6677 11.612ZM10.1101 12.066C10.105 13.1115 10.9558 13.9662 12.0017 13.9657C13.0451 13.9652 13.8828 13.1257 13.8868 12.0766C13.8914 11.0275 13.0431 10.1719 12.0002 10.1719C10.9659 10.1714 10.1146 11.0245 10.1101 12.066ZM8.60249 12.0715C8.60148 10.1825 10.1191 8.65851 12.0007 8.65749C13.8778 8.65648 15.404 10.1871 15.4035 12.071C15.403 13.9535 13.8747 15.4881 12.0012 15.4886C10.1252 15.4891 8.6035 13.9586 8.60249 12.0715Z"
      fill="currentColor"
    />
  </svg>
)

const EyeOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.05 3.33973C16.6435 3.10501 16.1236 3.2443 15.8889 3.65085L6.73888 19.4991C6.50416 19.9057 6.64345 20.4255 7.05 20.6602C7.45655 20.895 7.9764 20.7557 8.21112 20.3491L17.3611 4.50085C17.5958 4.0943 17.4565 3.57445 17.05 3.33973ZM11.8271 6.00021C12.2703 6.00011 12.6991 6.02434 13.1153 6.07198L12.2757 7.52619C12.1873 7.52093 12.0982 7.51822 12.0086 7.51813C9.47327 7.51559 7.47324 9.57375 7.46769 12.0572C7.46552 12.9996 7.74321 13.8581 8.20922 14.5695L6.94162 16.7651C6.45848 16.4872 5.99072 16.1715 5.53672 15.8221C4.33408 14.8971 3.30836 13.7974 2.38344 12.5979C2.34485 12.5479 2.3066 12.4975 2.26834 12.4472L2.26819 12.447L2.26817 12.447C2.19156 12.3462 2.11495 12.2454 2.03566 12.1468C1.99382 12.0947 1.98525 12.0607 2.0291 12.0025C3.08456 10.5914 4.24789 9.28464 5.66323 8.2224C6.97777 7.2356 8.41882 6.52272 10.0358 6.19564C10.2525 6.15159 10.4713 6.11463 10.6905 6.08476C11.1265 6.02502 11.565 5.99717 11.8271 6.00021ZM8.60249 12.0715C8.60155 10.3153 9.91322 8.87462 11.6096 8.67988L8.8758 13.415C8.70012 13.0026 8.60274 12.5484 8.60249 12.0715ZM15.0933 10.6459L12.3053 15.475C14.0373 15.3193 15.403 13.8506 15.4035 12.071C15.4036 11.5625 15.2925 11.0797 15.0933 10.6459ZM11.993 16.614C11.8787 16.6163 11.765 16.6138 11.6518 16.6067L10.8067 18.0706C10.9028 18.0821 10.9995 18.0923 11.0968 18.101C12.3019 18.2099 13.4869 18.1071 14.6528 17.7816C16.3882 17.297 17.8812 16.3801 19.2244 15.1953C20.2567 14.285 21.1433 13.243 21.9689 12.1448C22.0168 12.0815 22.0052 12.0445 21.9624 11.9904C21.8632 11.8652 21.7655 11.7387 21.6679 11.6123L21.6678 11.6122L21.6677 11.612L21.6676 11.612L21.6676 11.6119C21.5256 11.4281 21.3836 11.2442 21.2371 11.0643C20.2315 9.82842 19.108 8.71859 17.7824 7.82698C17.5254 7.65424 17.2649 7.49281 17.0002 7.34309L15.7512 9.50638C16.2493 10.2377 16.5395 11.1217 16.5359 12.0724C16.5258 14.7376 14.3302 16.6677 11.993 16.614ZM17.5747 14.5913C18.4915 13.8799 19.2945 13.0521 20.0329 12.1585C20.0934 12.0845 20.0828 12.044 20.0299 11.9797C19.4588 11.2912 18.8514 10.637 18.1775 10.0482C17.9547 9.85323 17.7294 9.66134 17.4749 9.47806C18.2345 11.2051 18.236 12.9154 17.4925 14.6282C17.5276 14.6331 17.5456 14.6169 17.5622 14.6019C17.5664 14.5982 17.5705 14.5945 17.5747 14.5913ZM5.65164 13.9407C5.9208 14.1837 6.19651 14.4202 6.49742 14.6288C5.76656 12.9098 5.77009 11.2005 6.52363 9.48211C6.51286 9.48937 6.50343 9.49555 6.49497 9.50109L6.49493 9.50112C6.47687 9.51296 6.46324 9.52189 6.45054 9.53223C5.51555 10.2547 4.6985 11.0967 3.94899 12.0086C3.89802 12.0702 3.92527 12.103 3.95792 12.1423L3.96462 12.1504C4.48731 12.7853 5.04175 13.3893 5.65164 13.9407Z"
      fill="currentColor"
    />
  </svg>
)

const ToggleButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: #999999;

  &:hover,
  &:focus {
    color: #666666;
  }
`

/**
 * Show/hide toggle for password inputs. Rendered inside a
 * position: relative container, overlaying the input's right edge.
 */
const PasswordToggle = ({ visible, onClick, className }) => (
  <ToggleButton
    type="button"
    className={className}
    aria-label={visible ? 'Hide password' : 'Show password'}
    aria-pressed={visible}
    onMouseDown={ev => ev.preventDefault()}
    onClick={onClick}
  >
    {visible ? <EyeOffIcon /> : <EyeIcon />}
  </ToggleButton>
)

PasswordToggle.propTypes = {
  visible: bool,
  onClick: func.isRequired,
  className: string,
}

export default PasswordToggle
